//引入刚才的http.js文件
import https from './http.js';
//设置个对象，就不用一个个暴露了，直接暴露对象
let apiFun = {};

//获取状态
apiFun.address = (params) => {
    return https.get('/admin/address', params)
}

//获取组织列表
apiFun.getorganizationlist = (params) => {
    return https.post('/admin/organization/query/all', params)
}

//获取网关列表
apiFun.getGatewayList = (params) => {
    return https.post('/admin/gateway/query/all', params)
}

//获取网络列表
apiFun.getNetworkList = (params) => {
    return https.post('/admin/network/query/all', params)
}

//获取网络网关列表
apiFun.getNetworkGatewaylist = (params) => {
    return https.post('/admin/network/gateway/query/all', params)
}

//获取网络设备列表
apiFun.getNetworkDevicelist = (params) => {
    return https.post('/admin/network/device/query/all', params)
}

//获取网络终端列表
apiFun.getNetworkTerminallist = (params) => {
    return https.post('/admin/network/terminal/query/all', params)
}

//获取实时数据列表
apiFun.getNetworkTimelist = (params) => {
    return https.post('/admin/realTime/query/all', params)
}

//获取升级任务列表
apiFun.getNetworkTasklist = (params) => {
    return https.post('/admin/upgrade/query/all', params)
}

// 登录
apiFun.login = (params) => {
    return https.post('/admin/login', params)
}
//添加管理员
apiFun.addadmin = (params) => {
    return https.post('/admin/administrators/add', params)
}
//添加SN码
apiFun.addsnma = (params) => {
    return https.post('/admin/sn/add', params)
}
//根据id删除SN码
apiFun.deletesnma = (params) => {
    return https.post('/admin/sn/delete', params)
}
//添加产品
apiFun.addproduct = (params) => {
    return https.post('/admin/product/add', params)
}
//添加产品图片
apiFun.addproductpic = (params) => {
    return https.post('/upload/image', params)
}
//根据id删除产品
apiFun.delproduct = (params) => {
    //console.log(`每页条`);
    //console.log(params);
    return https.delete('/admin/product/del/' + params.id)
}
//添加菜单
apiFun.addmenu = (params) => {
    return https.post('/addmenu', params)
}
//添加角色
apiFun.addrole = (params) => {
    return https.post('/admin/role/add', params)
}
//获取管理员列表
apiFun.selectadmin = (params) => {
    return https.post('/admin/administrators/query/all', params)
}
//sn获取产品列表
apiFun.selectprodsnt = (params) => {
    return https.post('/admin/product/query', params)
}
//获取产品列表
apiFun.selectproduct = (params) => {
    return https.post('/admin/product/query/all', params)
}
//修改产品
apiFun.editproduct = (params) => {
    return https.post('/admin/product/update', params)
}
//获取SN码列表
apiFun.selectsnma = (params) => {
    //return https.post('/admin/selectsnma', params)
    return https.post('/admin/sn/query/all', params)
}
//解绑SN码
apiFun.editsnma = (params) => {
    return https.post('/admin/sn/unbind', params)
}
//获取菜单列表
apiFun.selectmenu = (params) => {
    return https.post('/admin/menu/tree', params)
}
//获取菜单列表添加
apiFun.selectmadd = (params) => {
    return https.post('/admin/menu/tree/all', params)
}
//获取角色列表
apiFun.selectrole = (params) => {
    return https.post('/admin/role/query/all', params)
}
//修改管理员
apiFun.editadmin = (params) => {
    return https.post('/admin/administrators/modify', params)
}
//修改菜单
apiFun.editmenu = (params) => {
    return https.post('/admin/editmenu', params)
}
//修改角色
apiFun.editrole = (params) => {
    return https.post('/admin/role/modify', params)
}
//删除管理员
apiFun.deleteadmin = (params) => {
    return https.post('/admin/administrators/del', params)
}
//删除菜单
apiFun.deletemenu = (params) => {
    return https.post('/deletemenu', params)
}
//删除角色
apiFun.deleterole = (params) => {
    return https.post('/admin/role/del', params)
}
//cpu、内存获取
apiFun.getcpunc = (params) => {
    return https.get('/admin/overview', params)
}
//cpu、内存获取
apiFun.getcpunv = (params) => {
    return https.post('/admin/overview/product', params)
}
apiFun.getcpunb = (params) => {
    return https.post('/admin/overview/query', params)
}
apiFun.getbjsnx = (params) => {
    return https.post('/admin/sn/modify', params)
}
//超级用户注册
apiFun.enrollsuper = (params) => {
    return https.post('/enrollsuper', params)
}
//用户注册
apiFun.enroll = (params) => {
    return https.post('/enroll', params)
}
//获取所有网络列表
apiFun.networksall = (params) => {
    return https.post('/networksall', params)
}
//获取当前用户网络列表
apiFun.networks = (params) => {
    return https.post('/networks', params)
}
//获取当前用户项目列表
apiFun.project = (params) => {
    return https.post('/project', params)
}
//获取网络详细信息
apiFun.getnetworksDetail = (params) => {
    return https.post('/getnetworksDetail', params)
}
//获取网络信息
apiFun.networkchange = (params) => {
    return https.post('/networkchange', params)
}
//修改网络信息
apiFun.networkDetail = (params) => {
    return https.post('/networkDetail', params)
}
//修改设备数量
apiFun.changenumber = (params) => {
    return https.post('/changenumber', params)
}
//修改网络详细信息
apiFun.networksDetail = (params) => {
    return https.post('/networksDetail', params)
}
//获取设备所有列表
apiFun.getdevicelist = (params) => {
    return https.post('/getdevicelist', params)
}
//解决设备统计不正确
apiFun.getnetworkstj = (params) => {
    return https.post('/getnetworkstj', params)
}
//获取成员信息
apiFun.getnetworksMember = (params) => {
    return https.post('/getnetworksMember', params)
}
//获取成员详细信息
apiFun.getnetworksMemberdetail = (params) => {
    return https.post('/getnetworksMemberdetail', params)
}
//获取成员peer
apiFun.peer = (params) => {
    return https.post('/peer', params)
}
//修改成员详细信息
apiFun.memberDetail = (params) => {
    return https.post('/memberDetail', params)
}
//添加网络
apiFun.addnet = (params) => {
    return https.post('/addnet', params)
}
//删除网络
apiFun.networksDelete = (params) => {
    return https.post('/networksDelete', params)
}
//删除网络
apiFun.deleteuser = (params) => {
    return https.post('/deleteuser', params)
}
//修改设备名称
apiFun.equipmentname = (params) => {
    return https.post('/equipmentname', params)
}
//修改项目
apiFun.changeproject = (params) => {
    return https.post('/changeproject', params)
}
//获取设备名称
apiFun.getequipmentname = (params) => {
    return https.post('/getequipmentname', params)
}
//删除成员
apiFun.memberDelete = (params) => {
    return https.post('/memberDelete', params)
}
//获取所有项目
apiFun.getproject = (params) => {
    return https.post('/getproject', params)
}
//删除项目
apiFun.deleteproject = (params) => {
    return https.post('/deleteproject', params)
}
//手机注册获取短信
apiFun.mobile = (params) => {
    return https.post('/mobile', params)
}
//手机登录获取短信
apiFun.mobilelogin = (params) => {
    return https.post('/mobilelogin', params)
}

//忘记密码获取短信
apiFun.forgot = (params) => {
    return https.post('/nbforgot', params)
}
//忘记密码下一页
apiFun.pwdnextpage = (params) => {
    return https.post('/pwdnextpage', params)
}
//修改密码
apiFun.changepwd = (params) => {
    return https.post('/nbchangepwd', params)
}
//查询用户信息
apiFun.selectuser = (params) => {
    return https.post('/admin/user/query/all', params)
}
//头像功能
apiFun.head = (params) => {
    return https.post('/head', params)
}
//设备图片功能
apiFun.equipmentimg = (params) => {
    return https.post('/equipmentimg', params)
}
//修改头像信息信息
apiFun.updathead = (params) => {
    return https.post('/updathead', params)
}
//修改设备图片信息
apiFun.updatequipment = (params) => {
    return https.post('/updatequipment', params)
}
//修改用户信息
apiFun.updateuser = (params) => {
    return https.post('/updateuser', params)
}
//修改手机号
apiFun.changemobile = (params) => {
    return https.post('/changemobile', params)
}
//添加项目
apiFun.addproject = (params) => {
    return https.post('/addproject', params)
}
//修改邮箱
apiFun.setemail = (params) => {
    return https.post('/setemail', params)
}
//获取设备地址
apiFun.getequipment = (params) => {
    return https.post('/getequipment', params)
}
//获取设备地址
apiFun.alipay = (params) => {
    return https.post('/alipay', params)
}
//获取设备地址
apiFun.orderlist = (params) => {
    return https.post('/orderlist', params)
}
//获取用户列表详情
apiFun.userdetaillist = (params) => {
    return https.post('/admin/user/details', params)
}
//获取用户列表详情-网关详情
apiFun.userdetailgatewaylist = (params) => {
    return https.post('/gateway/query/all', params)
}
//获取用户列表详情-网关详情-所属组织
apiFun.userdetailAffiliatedOrganize = (params) => {
    return https.post('/organization/inquiry', params)
}
//获取用户列表详情-成员详情
apiFun.userdetailMemberlist = (params) => {
    return https.post('/organization/user/query/all', params)
}
//获取用户列表详情-资源详情
apiFun.userdetailResourcelist = (params) => {
    return https.post('/resource/query', params)
}
//获取SN管理-详情数据
apiFun.sndetaildata = (sn) => {
    return https.get(`/gateway/sysinfo/${sn}`)
}
//获取订单管理-订单详情
apiFun.selectorderdetail = (params) => {
    return https.post('/order/query/all', params)
}
//获取首页-状态数据
apiFun.overviewstatus = () => {
    return https.get('/admin/overview')
}
//获取首页-短信余量
apiFun.overviewbalance = () => {
    return https.get('/admin/depend/query')
}
//获取首页-中间部分数据
apiFun.overviewmenudata = () => {
    return https.get('/admin/system/info')
}
//首页-柱状图
apiFun.overviewproduct = () => {
    return https.get('/admin/overview/product')
}
//增值服务-列表
apiFun.valueaddedlist = (params) => {
    return https.post('/admin/valueAdded/query/all', params)
}
//增值服务-编辑
apiFun.valueaddedupdate = (params) => {
    return https.post('/admin/valueAdded/update', params)
}
//增值服务-新增
apiFun.valueaddedadd = (params) => {
    return https.post('/admin/valueAdded/add', params)
}
//增值服务-删除
apiFun.valueaddeddelete = (id) => {
    return https.delete(`/admin/valueAdded/del/${id}`)
}
//系统设置-总体数据
apiFun.systemsettingconfig = (params) => {
    return https.get('/admin/config', params)
}
//系统设置-单项修改
apiFun.systemsettingupdate = (params) => {
    return https.post('/admin/config/update', params)
}
//系统设置-主题内容
apiFun.systemsettingtheme = () => {
    return https.get('/admin/default/config')
}
//系统设置-主题内容
apiFun.systemsettingthemeupload = (params) => {
    return https.post('/admin/default/config/upload', params)
}
//用户列表-用户按钮
apiFun.userdataregister = (params) => {
    return https.post('/user/admin/register', params)
}
//用户列表-用户按钮
apiFun.userdelete = (id) => {
    return https.delete(`/admin/user/delete/${id}`)
}
//备份与恢复-列表数据
apiFun.backupfilesdata = (params) => {
    return https.post('/admin/backup/files', params)
}
//备份与恢复-删除
apiFun.backupfilesdelete = (params) => {
    return https.post('/admin/backup/delete', params)
}
//备份与恢复-新建备份
apiFun.addbackup = (params) => {
    return https.post('/admin/backup', params)
}
//备份与恢复-下载
apiFun.addbackupdownload = (params) => {
    return https.post1('/admin/backup/download', params)
}
//备份与恢复-恢复
apiFun.addbackuprecovery = (params) => {
    return https.post('/admin/recovery', params)
}
//公告设置
apiFun.noticeSettingUpload = (params) => {
    return https.post('/admin/notice/upload', params)
}
// 发布公告
apiFun.releaseNotice = (params) => {
    return https.post('/admin/notice/release', params)
}
// 获取公告设置信息
apiFun.getNoticeSettingsInfo = (params) => {
    return https.get('/admin/notice/config', params)
}

export default apiFun;
